import {Component, Input, OnInit} from '@angular/core';

export interface TractorsFuelConsumption {
  domainID: number;
  domainName: string;
  data: {
    tractor: string;
    consumption: number;
  }[];
}

@Component({
  selector: 'app-tractors-fuel-consumption-widget',
  templateUrl: './tractors-fuel-consumption-widget.component.html',
  styleUrls: ['./tractors-fuel-consumption-widget.component.scss']
})
export class TractorsFuelConsumptionWidgetComponent implements OnInit {

  @Input()
  data: TractorsFuelConsumption[];

  constructor() {
  }

  ngOnInit(): void {
  }

}
